import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a6665b6a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-h5-v2023"
};
const _hoisted_2 = {
  class: "nav"
};
const _hoisted_3 = {
  class: "menu"
};
const _hoisted_4 = {
  class: "search"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ico ico-search"
}, null, -1));
import { onMounted, computed, inject } from "vue";
import { useRoute, useRouter } from "vue-router";
import { homeCategoryTable } from "@/composable/commonFunction/categoryTable";
import recommendTabsH5 from "@/components/h5/common/recommendTabsH5.vue";
import { promoteUrl } from "@/utils/url";
import store from '@/store';
export default {
  __name: 'headerV2H5',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const {
      activeHeaderTab,
      switchHeaderTab
    } = inject('activeHeaderTab');

    // 由 route 參數決定 Header activeClass
    const activeClass = computed(() => {
      if (route.name !== 'home') {
        return '';
      }
      let temp = [...homeCategoryTable].filter(item => item.val === +route.query.forum).length ? [...homeCategoryTable].filter(item => item.val === +route.query.forum) : [...homeCategoryTable].filter(item => item.home);
      if (temp[0]['level'] !== 'header') {
        temp = [...homeCategoryTable].filter(item => item.subject === temp[0]['subject'].split('-')[0]);
      }
      return temp[0]['key'] || '';
    });

    // header跳轉路由及登入驗證
    const headerRouter = header => {
      const params = homeCategoryTable.filter(item => item.key === header);
      if (params[0]['requireAuth'] && !store.state.user.isLogin) {
        const url = document.URL;
        window.location.replace(promoteUrl() + '/member_vue.php?platform=2&method=login&back=' + encodeURIComponent(url));
        return;
      }
      switchHeaderTab(header);
      router.push({
        name: 'home',
        query: {
          forum: params[0]['val']
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("nav", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass([{
          'active': _unref(activeClass) === 'recommend'
        }]),
        onClick: _cache[0] || (_cache[0] = $event => headerRouter('recommend'))
      }, "DU圈", 2), _createElementVNode("div", {
        class: _normalizeClass([{
          'active': _unref(activeClass) === 'ranking'
        }]),
        onClick: _cache[1] || (_cache[1] = $event => headerRouter('ranking'))
      }, "热榜", 2), _createElementVNode("div", {
        class: _normalizeClass([{
          'active': _unref(activeClass) === 'follow'
        }]),
        onClick: _cache[2] || (_cache[2] = $event => headerRouter('follow'))
      }, "关注", 2)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
        class: "nav-btn",
        to: "/search"
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      })])])]);
    };
  }
};